import { SettlementPlanType } from '@g2-shared/api-client/generated/settlement-app';

export const SettlementPlanTypeLabelMapper: Record<SettlementPlanType, string> = {
  [SettlementPlanType.PERIODIC]: 'Periodic_settlement_plan',
  [SettlementPlanType.CONTINUOUS]: 'Continuous_settlement_plan',
};
